import React, { useState, useEffect } from 'react';
import { Input, Tabs, Button, Modal, Form, Select, Menu as AntMenu, Grid, Table, Checkbox, Radio } from 'antd';

import { EditOutlined, ScheduleOutlined, EyeOutlined, DeleteOutlined, SendOutlined, FilePdfOutlined, PrinterOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { productsService } from "../../services/ProductsService";
import Menu from '../../components/Menu/Menu';
import './Lists.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";
import { providersService } from "../../services/ProvidersService";
import ListStatusGuard from './ListStatusGuard';

import { useLocation } from 'react-router-dom';
import { bidingService } from "../../services/BidingService";
import moment from 'moment';
import StatusTag from '../../components/StatusTag/StatusTag';

const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;
const VerticalDotsIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ cursor: 'pointer' }}
    >
        <circle cx="12" cy="5" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="12" cy="19" r="2" />
    </svg>
);

const toDateTimeLocalValue = (dateMoment) => dateMoment.seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm');

const ReadyToSend = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
    const [isDirectSendModalVisible, setIsDirectSendModalVisible] = useState(false);
    const [scheduleStep, setScheduleStep] = useState(1);
    const [scheduledDate, setScheduledDate] = useState(null);
    const [scheduledDateInput, setScheduledDateInput] = useState('');
    const [selectedSuppliersOption, setSelectedSuppliersOption] = useState('all');
    const [selectedScheduleSupplierIds, setSelectedScheduleSupplierIds] = useState([]);
    const [selectedSupplierIds, setSelectedSupplierIds] = useState([]);
    const [selectedDeliveryMethods, setSelectedDeliveryMethods] = useState(['email']);
    const [suppliersList, setSuppliersList] = useState([]);

    const [selectedList, setSelectedList] = useState(null);
    const [selectedSublistContext, setSelectedSublistContext] = useState(null); // { listId, sublistId }
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [form] = Form.useForm();
    const [scheduleForm] = Form.useForm();
    const [listExists, setListExists] = useState(false);
    const [listId, setListId] = useState(null);
    const [lists, setLists] = useState([]);
    const [currentList, setCurrentList] = useState(null);
    const [index, setIndex] = useState(-1);
    const [editingListId, setEditingListId] = useState(null);
    const [editedName, setEditedName] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isBulkDeleteModalVisible, setIsBulkDeleteModalVisible] = useState(false);
    const [isMergeModalVisible, setIsMergeModalVisible] = useState(false);
    const [newListTitle, setNewListTitle] = useState('');
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [subTableData, setSubTableData] = useState({});
    const [counts, setCounts] = useState({});

    // Mobile detection using Ant Design Grid
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md; // md breakpoint is 768px
    const pathToKey = {
        '/liste-necesar': 'creeaza',
        '/gata-de-trimis': 'gata',
        '/liste-in-ofertare': 'ofertare',
        '/liste-ofertate': 'ofertate',
        '/procesare-manuala': 'procesareManuala',

        '/liste-arhivate': 'arhivate',

    };
    const selectedMenuKey = pathToKey[location.pathname];

    const fetchReadyToSendLists = () => {
        listService.getLists('ready_to_send')
            .then(res => {
                if (res.data) {
                    setLists(res.data.necessity_lists);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    };

    const fetchSuppliers = () => {
        providersService.getWhatsAppProviders()
            .then(res => {
                if (res.data) {
                    setSuppliersList(res.data);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    };

    useEffect(() => {
        handleSearch('');
        fetchReadyToSendLists();
        fetchSuppliers();


    }, []);
    useEffect(() => {

        listService.getCounts()
            .then(res => {
                if (res.data) {
                    setCounts(res.data.list_counts);

                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });

    }, []);

    const rowSelection = {
        selectedRowKeys,
        columnWidth: 64,
        onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: !ListStatusGuard.canMergeList(record.status),
        }),
    };

    const handleExpandRow = (expanded, record) => {
        const listId = record.id;
        if (expanded) {
            listService.getSublist(listId)
                .then(res => {
                    const sublists = res?.data?.sublists || [];
                    setSubTableData(prev => ({
                        ...prev,
                        [listId]: sublists
                    }));
                    if (sublists.length > 0) {
                        setExpandedRowKeys(prev => [...prev, listId]);
                    } else {
                        setExpandedRowKeys(prev => prev.filter(id => id !== listId));
                    }
                })
                .catch(error => {
                    console.error("Eroare la încărcarea subtablei:", error);
                });
        } else {
            setExpandedRowKeys(prev => prev.filter(id => id !== listId));
        }
    };
    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            listService.searchList(value, 1, 'ready_to_send')
                .then(res => {
                    if (res.data?.necessity_lists) {
                        setSearchResults(res.data.necessity_lists);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };
    const showEditModal = (list) => {
        setCurrentList(list);
        form.setFieldsValue({
            name: list.name,
            description: list.description || ''
        });
    };
    const handleEditSubmit = () => {
        form
            .validateFields()
            .then(values => {
                const updatedList = {
                    ...currentList,
                    name: values.name,
                    description: values.description,
                };

                listService.updateList(updatedList.id, updatedList)
                    .then(() => {
                        toast.success('Lista a fost actualizată cu succes');
                        setLists(prev =>
                            prev.map(item => item.id === updatedList.id ? updatedList : item)
                        );
                    })
                    .catch(err => {
                        console.error("Eroare la actualizarea listei:", err);
                        toast.error('Eroare la actualizarea listei');
                    });
            });
    };

    const handleMenuClick = (action, record) => {
        const canEditList = ListStatusGuard.canManageProducts(record.status);
        const canSetProgrammed = ListStatusGuard.canSetProgrammed(record.status);
        const canDirectSendList = ListStatusGuard.canDirectSendList(record.status);
        const canDeleteList = ListStatusGuard.canDeleteList(record.status);

        switch (action) {
            case 'view':
                navigate(`/liste-necesar/${record.id}`);
                break;

            case 'schedule':
                if (!canSetProgrammed) {
                    return;
                }
                const nowDateValue = toDateTimeLocalValue(moment().add(5, 'minutes'));
                setSelectedList(record);
                setScheduleStep(1);
                setScheduledDateInput(nowDateValue);
                setScheduledDate(moment(nowDateValue).toISOString());
                scheduleForm.setFieldsValue({ date: nowDateValue });
                setSelectedSuppliersOption('all');
                setSelectedScheduleSupplierIds([]);
                setIsScheduleModalVisible(true);
                console.log('test');

                break;
            case 'send':
                if (!canDirectSendList) {
                    return;
                }
                console.log("Trimite lista:", record.id);
                setSelectedList(record);
                setSelectedSublistContext(null);
                setSelectedDeliveryMethods(['email']);
                setIsDirectSendModalVisible(true);

                break;
            case 'delete':
                if (!canDeleteList) {
                    return;
                }
                showDeleteModal(record);
                break;
            case 'downloadPdf':
                {
                    const loadingToastId = toast.loading('Se generează PDF-ul...');
                    listService
                        .downloadListPdf(record.id)
                        .then((response) => {
                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            const filename = `lista-${record.id}.pdf`;
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(url);
                            toast.update(loadingToastId, { render: 'Descărcarea a început', type: 'success', isLoading: false, autoClose: 2000 });
                        })
                        .catch(() => {
                            toast.update(loadingToastId, { render: 'Eroare la descărcarea PDF-ului', type: 'error', isLoading: false, autoClose: 3000 });
                        });
                }
                break;
            case 'printPdf':
                {
                    const loadingToastId = toast.loading('Se generează PDF-ul pentru print...');
                    listService
                        .downloadListPdf(record.id)
                        .then((response) => {
                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const blobUrl = window.URL.createObjectURL(blob);

                            const iframe = document.createElement('iframe');
                            iframe.style.position = 'fixed';
                            iframe.style.right = '0';
                            iframe.style.bottom = '0';
                            iframe.style.width = '0';
                            iframe.style.height = '0';
                            iframe.style.border = '0';
                            iframe.src = blobUrl;
                            document.body.appendChild(iframe);

                            const cleanup = () => {
                                try { window.URL.revokeObjectURL(blobUrl); } catch (_) { }
                                if (iframe && iframe.parentNode) {
                                    iframe.parentNode.removeChild(iframe);
                                }
                            };

                            iframe.onload = () => {
                                try {
                                    toast.dismiss(loadingToastId);

                                    const printWindow = iframe.contentWindow || window;

                                    const afterPrint = () => {
                                        cleanup();
                                        printWindow.removeEventListener('afterprint', afterPrint);
                                        window.removeEventListener('focus', onFocus);
                                    };

                                    const onFocus = () => {
                                        setTimeout(() => cleanup(), 500);
                                    };

                                    printWindow.addEventListener('afterprint', afterPrint);
                                    window.addEventListener('focus', onFocus, { once: true });

                                    printWindow.focus();
                                    printWindow.print();
                                } catch (e) {
                                    cleanup();
                                    toast.error('Eroare la deschiderea dialogului de printare');
                                }
                            };
                        })
                        .catch(() => {
                            toast.update(loadingToastId, { render: 'Eroare la generarea PDF-ului pentru print', type: 'error', isLoading: false, autoClose: 3000 });
                        });
                }
                break;
            default:
                break;
        }
    };
    const handleSublistMenuClick = (action, record) => {
        const listId = record.listId;
        const sublistId = record.id;
        const canDirectSendSublist = ListStatusGuard.canDirectSendSublist(record);
        switch (action) {
            case 'view':
                navigate(`/lists/${listId}/products/${sublistId}`);
                break;


            case 'send':
                if (!canDirectSendSublist) {
                    return;
                }
                setSelectedList(null);
                setSelectedSublistContext({ listId, sublistId });
                setSelectedDeliveryMethods(['email']);
                setIsDirectSendModalVisible(true);
                break;
            case 'downloadPdf':
                const loadingToastId = toast.loading('Se generează PDF-ul...');
                listService
                    .downloadSublistPdf(listId, sublistId)
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        const filename = `sublista-${listId}-${sublistId}.pdf`;
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                        toast.update(loadingToastId, { render: 'Descărcarea a început', type: 'success', isLoading: false, autoClose: 2000 });
                    })
                    .catch(() => {
                        toast.update(loadingToastId, { render: 'Eroare la descărcarea PDF-ului', type: 'error', isLoading: false, autoClose: 3000 });
                    });

                break;
            case 'printPdf':
                {
                    const loadingToastId2 = toast.loading('Se generează PDF-ul pentru print...');
                    listService
                        .downloadSublistPdf(listId, sublistId)
                        .then((response) => {
                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const blobUrl = window.URL.createObjectURL(blob);

                            const iframe = document.createElement('iframe');
                            iframe.style.position = 'fixed';
                            iframe.style.right = '0';
                            iframe.style.bottom = '0';
                            iframe.style.width = '0';
                            iframe.style.height = '0';
                            iframe.style.border = '0';
                            iframe.src = blobUrl;
                            document.body.appendChild(iframe);

                            const cleanup = () => {
                                try { window.URL.revokeObjectURL(blobUrl); } catch (_) { }
                                if (iframe && iframe.parentNode) {
                                    iframe.parentNode.removeChild(iframe);
                                }
                            };

                            iframe.onload = () => {
                                try {
                                    // Închidem loader-ul înainte de a deschide dialogul de print pentru a evita probleme de focus
                                    toast.dismiss(loadingToastId2);

                                    const printWindow = iframe.contentWindow || window;

                                    const afterPrint = () => {
                                        cleanup();
                                        printWindow.removeEventListener('afterprint', afterPrint);
                                        window.removeEventListener('focus', onFocus);
                                    };

                                    const onFocus = () => {
                                        // Fallback cleanup după ce utilizatorul închide dialogul de print și fereastra recapătă focusul
                                        setTimeout(() => cleanup(), 500);
                                    };

                                    // În unele browsere, afterprint se declanșează doar pe fereastra care face print
                                    printWindow.addEventListener('afterprint', afterPrint);
                                    window.addEventListener('focus', onFocus, { once: true });

                                    printWindow.focus();
                                    printWindow.print();
                                } catch (e) {
                                    cleanup();
                                    toast.error('Eroare la deschiderea dialogului de printare');
                                }
                            };
                        })
                        .catch(() => {
                            toast.update(loadingToastId2, { render: 'Eroare la generarea PDF-ului pentru print', type: 'error', isLoading: false, autoClose: 3000 });
                        });
                }
                break;
            default:
                break;
        }
    };
    const expandedRowRender = (record) => {
        const listId = record.id;
        const data = (subTableData[listId] || []).map(item => ({
            ...item,
            listId: listId,
        }));

        const columns = [
            { title: 'Furnizor', dataIndex: 'supplier_name', key: 'supplier_name' },
            {
                title: 'Produse netrimise',
                dataIndex: 'unsent_items_count',
                key: 'unsent_items',
                render: (value, record) => {
                    const total = Number(record?.total_items_count) || 0;
                    const unsent = Number(value) || 0;
                    return `${unsent} / ${total}`;
                },
            },
            {
                title: 'Ultima trimitere', dataIndex: 'updated_at', key: 'updated_at',
                render: (value) => new Date(value).toLocaleDateString('ro-RO'),
            },

            {
                title: 'Acțiuni',
                key: 'actions',
                width: 100,
                render: (_, record) => {
                    const canDirectSendSublist = ListStatusGuard.canDirectSendSublist(record);

                    const menuItems = [
                        {
                            key: 'view',
                            label: 'Vezi sublista',
                            icon: <EyeOutlined />,
                        },
                        {
                            key: 'send',
                            label: 'Trimite sublista',
                            icon: <SendOutlined />,
                            disabled: !canDirectSendSublist,
                        },
                        {
                            key: 'downloadPdf',
                            label: 'Descarca PDF',
                            icon: <FilePdfOutlined />,
                        },
                        {
                            key: 'printPdf',
                            label: 'Printează sublista',
                            icon: <PrinterOutlined />,
                        },
                    ];

                    return (
                        <Dropdown
                            menu={{
                                items: menuItems,
                                onClick: ({ key }) => handleSublistMenuClick(key, record)
                            }}
                            trigger={['click']}
                            placement="bottomRight"
                        >
                            <Button icon={<VerticalDotsIcon />} />
                        </Dropdown>
                    );
                },
            },
        ];

        return (
            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                pagination={false}
                scroll={{ x: true }}
            />
        );
    };

    // Helper function for name render (used in both desktop and mobile)
    const renderName = (text, record) => {
        const isExpanded = expandedRowKeys.includes(record.id);
        const canEditList = ListStatusGuard.canManageProducts(record.status);

        if (editingListId === record.id) {
            return (
                <Input
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                    onBlur={() => handleNameSave(record)}
                    onPressEnter={() => handleNameSave(record)}
                    autoFocus
                />
            );
        }
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <span style={{ flex: 1 }}>{text}</span>
                <EditOutlined
                    style={{
                        marginLeft: 8,
                        color: canEditList ? '#1890ff' : '#bfbfbf',
                        cursor: canEditList ? 'pointer' : 'not-allowed'
                    }}
                    onClick={() => {
                        if (!canEditList) {
                            return;
                        }

                        setEditingListId(record.id);
                        setEditedName(record.title);
                    }}
                />
                {record.has_sublists === true && (
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        style={{ cursor: 'pointer', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
                        onClick={() => handleExpandRow(!isExpanded, record)}
                    >
                        <path d="M7 10l5 5 5-5z" />
                    </svg>
                )}
            </div>
        );
    };

    // Helper function for status render (used in both desktop and mobile)
    const renderStatus = (status) => <StatusTag status={status} />;

    // Helper function for actions render (used in both desktop and mobile)
    const renderActions = (_, record) => {
        const canEditList = ListStatusGuard.canManageProducts(record.status);
        const canSetProgrammed = ListStatusGuard.canSetProgrammed(record.status);
        const canDirectSendList = ListStatusGuard.canDirectSendList(record.status);
        const canDeleteList = ListStatusGuard.canDeleteList(record.status);

        const menuItems = [
            {
                key: 'view',
                label: 'Vezi / Editeaza lis...',
                icon: <EyeOutlined />,
            },
            {
                key: 'schedule',
                label: 'Programează bid',
                icon: <ScheduleOutlined />,
                disabled: !canSetProgrammed,
            },
            {
                key: 'send',
                label: 'Trimite lista',
                icon: <SendOutlined />,
                disabled: !canDirectSendList,
            },
            {
                key: 'downloadPdf',
                label: 'Descarcă PDF',
                icon: <FilePdfOutlined />,
            },
            {
                key: 'printPdf',
                label: 'Printeaza lista',
                icon: <PrinterOutlined />,
            },
            {
                key: 'delete',
                label: 'Sterge lista',
                icon: <DeleteOutlined />,
                danger: true,
                disabled: !canDeleteList,
            },
        ];

        return (
            <Dropdown
                menu={{
                    items: menuItems,
                    onClick: ({ key }) => handleMenuClick(key, record)
                }}
                trigger={['click']}
                placement="bottomRight"
            >
                <Button icon={<VerticalDotsIcon />} />
            </Dropdown>
        );
    };

    // Desktop columns (all columns)
    const listColumnsDesktop = [
        {
            title: 'Număr listă',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Nume',
            dataIndex: 'title',
            key: 'title',
            render: renderName,
        },
        {
            title: 'Data creare',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 140,
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 160,
            render: renderStatus,
        },
        {
            title: 'Programat pe',
            dataIndex: 'programmed_date',
            key: 'programmed_date',
            width: 180,
            render: (value) =>
                value
                    ? moment(value).format('DD.MM.YYYY HH:mm')
                    : '—',
        },
        {
            title: 'Acțiuni',
            key: 'actions',
            width: 100,
            render: renderActions,
        },
    ];

    // Mobile columns (only: Nr, Nume (larger), Status, Opțiuni)
    const listColumnsMobile = [
        {
            title: 'Nr',
            dataIndex: 'id',
            key: 'id',
            width: 60,
        },
        {
            title: 'Nume',
            dataIndex: 'title',
            key: 'title',
            flex: 1,
            render: renderName,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 140,
            render: renderStatus,
        },
        {
            title: 'Opțiuni',
            key: 'actions',
            width: 60,
            render: renderActions,
        },
    ];

    // Use mobile or desktop columns based on screen size
    const listColumns = isMobile ? listColumnsMobile : listColumnsDesktop;

    // Mobile List Component - Table-like layout (same as CreateList)
    const MobileList = () => {
        const dataSource = searchQuery.length > 0 ? searchResults : lists;

        if (dataSource.length === 0) {
            return (
                <div className="list__empty-state">
                    <p className="list__empty-state-text">
                        Niciun produs găsit.
                    </p>
                </div>
            );
        }

        return (
            <div className="list__mobile-table-wrapper">
                {/* Table Header */}
                <div className="list__mobile-table-header">
                    <div className="list__mobile-table-header-cell" style={{ width: '20px', flexShrink: 0 }}>
                        Nr
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-name">
                        Nume
                    </div>
                    <div className="list__mobile-table-header-cell" style={{ width: '80px', flexShrink: 0 }}>
                        Status
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-actions" style={{ width: '20px', flexShrink: 0 }}>
                        Opt
                    </div>
                </div>

                {/* Table Rows */}
                <div className="list__mobile-list">
                    {dataSource.map((row) => {
                        const canEditList = ListStatusGuard.canManageProducts(row.status);
                        const canSetProgrammed = ListStatusGuard.canSetProgrammed(row.status);
                        const canDirectSendList = ListStatusGuard.canDirectSendList(row.status);
                        const canDeleteList = ListStatusGuard.canDeleteList(row.status);
                        const menuItems = [
                            {
                                key: 'view',
                                label: 'Vezi / Editeaza lista',
                                icon: <EyeOutlined />,
                            },
                            {
                                key: 'schedule',
                                label: 'Programează bid',
                                icon: <ScheduleOutlined />,
                                disabled: !canSetProgrammed,
                            },
                            {
                                key: 'send',
                                label: 'Trimite lista',
                                icon: <SendOutlined />,
                                disabled: !canDirectSendList,
                            },
                            {
                                key: 'downloadPdf',
                                label: 'Descarcă PDF',
                                icon: <FilePdfOutlined />,
                            },
                            {
                                key: 'printPdf',
                                label: 'Printeaza lista',
                                icon: <PrinterOutlined />,
                            },
                            {
                                key: 'delete',
                                label: 'Sterge lista',
                                icon: <DeleteOutlined />,
                                danger: true,
                                disabled: !canDeleteList,
                            },
                        ];

                        return (
                            <div key={row.id} className="list__mobile-card">
                                <div className="list__mobile-card-cell" style={{ width: '20px', flexShrink: 0 }}>
                                    {row.id}
                                </div>
                                <div className="list__mobile-card-cell list__mobile-card-name" title={row.title}>
                                    {editingListId === row.id ? (
                                        <Input
                                            value={editedName}
                                            onChange={(e) => setEditedName(e.target.value)}
                                            onBlur={() => handleNameSave(row)}
                                            onPressEnter={() => handleNameSave(row)}
                                            autoFocus
                                            style={{ width: '100%' }}
                                        />
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{ flex: 1 }}>{row.title}</span>
                                            <EditOutlined
                                                style={{
                                                    color: canEditList ? '#1890ff' : '#bfbfbf',
                                                    cursor: canEditList ? 'pointer' : 'not-allowed',
                                                    flexShrink: 0
                                                }}
                                                onClick={() => {
                                                    if (!canEditList) {
                                                        return;
                                                    }

                                                    setEditingListId(row.id);
                                                    setEditedName(row.title);
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="list__mobile-card-cell" style={{ width: '80px', flexShrink: 0 }}>
                                    {renderStatus(row.status)}
                                </div>
                                <div className="list__mobile-card-cell list__mobile-card-actions" style={{ width: '20px', flexShrink: 0 }}>
                                    <Dropdown
                                        menu={{
                                            items: menuItems,
                                            onClick: ({ key }) => handleMenuClick(key, row)
                                        }}
                                        trigger={['click']}
                                        placement="bottomRight"
                                    >
                                        <Button
                                            type="text"
                                            className="list__mobile-card-actions-btn"
                                            style={{ padding: 0, border: 'none', background: 'transparent' }}
                                        >
                                            <VerticalDotsIcon />
                                        </Button>
                                    </Dropdown>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };
    const handleDeleteList = list => {
        console.log('aici')
        console.log(list)
        listService.deleteList(list.id)
            .then(() => {
                toast.success('Stergere reusita')
                setLists(prevLists => prevLists.filter(item => item.id !== list.id));
                setIsDeleteModalVisible(false)
            })
            .catch(error => {
                console.error('Eroare');
                setIsDeleteModalVisible(false);
            });
    };
    const showDeleteModal = (list) => {
        setCurrentList(list);

        setIsDeleteModalVisible(true);
    };

    const handleCancelDelete = () => {
        setIsDeleteModalVisible(false);
    };
    const handleNameSave = (list) => {
        if (!editedName || editedName === list.title) {
            setEditingListId(null);
            return;
        }

        const updatedList = { ...list, title: editedName };
        console.log('aici!!!!!')
        console.log(updatedList)

        listService.updateList(updatedList.id, updatedList)
            .then(() => {
                toast.success('Numele listei a fost actualizat cu succes');
                setLists(prev =>
                    prev.map(item => item.id === updatedList.id ? updatedList : item)
                );
            })
            .catch(err => {
                toast.error('Eroare la actualizarea listei');
                console.error(err);
            })
            .finally(() => {
                setEditingListId(null);
            });
    };
    const handleBulkDelete = () => {
        listService.deleteLists(selectedRowKeys)
            .then(() => {
                toast.success('Listele au fost șterse cu succes');
                setLists(prev => prev.filter(item => !selectedRowKeys.includes(item.id)));
                setSelectedRowKeys([]);
            })
            .catch(() => {
                toast.error('Eroare la ștergerea listelor');
            })
            .finally(() => {
                setIsBulkDeleteModalVisible(false);
            });
    };
    const handleMergeLists = (title) => {
        listService.mergeLists(selectedRowKeys, title)
            .then(() => {
                toast.success('Listele au fost unite cu succes');
                setSelectedRowKeys([]);
                fetchReadyToSendLists();
            })
            .catch(() => {
                toast.error('Eroare la unirea listelor');
            })

    };

    const handleDirectSend = () => {
        const deliveryMethod = selectedDeliveryMethods[0];
        if (!deliveryMethod) {
            toast.error('Selectează metoda de trimitere.');
            return;
        }

        const isSublistContext = !!selectedSublistContext;
        const request = isSublistContext
            ? listService.directSendSublist(
                selectedSublistContext.listId,
                selectedSublistContext.sublistId,
                selectedSupplierIds,
                deliveryMethod
            )
            : listService.directSendList(selectedList.id, selectedSupplierIds, deliveryMethod);

        request
            .then(() => {
                toast.success('Lista / Sublista a fost trimisa cu succes');
                setSelectedRowKeys([]);
                fetchReadyToSendLists();
            })
            .catch(() => {
                toast.error('Eroare la trimitere');
            })
    }

    const scheduleList = () => {
        if (!scheduledDate || !selectedList) {
            toast.error("Datele nu sunt complete.");
            return;
        }
        if (moment(scheduledDate).isBefore(moment())) {
            toast.error("Data programată nu poate fi în trecut.");
            return;
        }
        if (selectedSuppliersOption === 'custom' && selectedScheduleSupplierIds.length === 0) {
            toast.error("Selectează cel puțin un furnizor.");
            return;
        }

        bidingService.scheduleBid(selectedList.id, scheduledDate, {
            allSuppliers: selectedSuppliersOption === 'all',
            supplierIds: selectedSuppliersOption === 'custom' ? selectedScheduleSupplierIds : []
        })
            .then(() => {
                toast.success('Licitația a fost programată cu succes');
                setIsScheduleModalVisible(false);
                setScheduleStep(1);
                setSelectedSuppliersOption('all');
                setSelectedScheduleSupplierIds([]);

                return listService.getLists('ready_to_send');
            })
            .then((res) => {
                if (res.data) {
                    setLists(res.data.necessity_lists);
                }
            })
            .catch((error) => {
                toast.error('Eroare la programarea licitației');
                console.error(error);
            });
    };

    const closeScheduleModal = () => {
        setIsScheduleModalVisible(false);
        setScheduleStep(1);
        setScheduledDate(null);
        setScheduledDateInput('');
        scheduleForm.resetFields();
        setSelectedSuppliersOption('all');
        setSelectedScheduleSupplierIds([]);
    };

    const handleScheduledDateChange = (rawValue) => {
        setScheduledDateInput(rawValue);
        scheduleForm.setFieldsValue({ date: rawValue });
        if (!rawValue) {
            setScheduledDate(null);
            return;
        }

        setScheduledDate(moment(rawValue).toISOString());
    };
    return (
        <div className='standard products list'>
            <Header />


            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Gata de trimis</h2>
                        <h4 className='standard__page-info'>
                            În acest tabel, listele de necesar pot fi editate și programate pentru ofertare.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută lista..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                            />

                        </div>
                        <div className='list__tabs-wrapper'>
                            <AntMenu
                                mode="horizontal"
                                selectedKeys={[selectedMenuKey]}
                                style={{ marginTop: 16 }}
                                onClick={(e) => {
                                    switch (e.key) {
                                        case 'creeaza':
                                            navigate('/liste-necesar');
                                            break;
                                        case 'gata':
                                            navigate('/gata-de-trimis');
                                            break;
                                        case 'ofertare':
                                            navigate('/liste-in-ofertare');
                                            break;
                                        case 'ofertate':
                                            navigate('/liste-ofertate');
                                            break;
                                        case 'procesareManuala':
                                            navigate('/procesare-manuala');
                                            break;
                                        case 'arhivate':
                                            navigate('/liste-arhivate');
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            >
                                <AntMenu.Item key="creeaza">Creează listă</AntMenu.Item>
                                <AntMenu.Item key="gata">
                                    Gata de trimis ({counts.ready_to_send || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertare">
                                    Liste în ofertare ({counts.offering || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertate">
                                    Liste ofertate ({counts.offered || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="procesareManuala">
                                    Procesare manuala ({counts.manual_processing || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="arhivate">
                                    Liste arhivate ({counts.archived || 0})
                                </AntMenu.Item>
                            </AntMenu>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>


                            {currentList && currentList.created_at && (
                                <div style={{ textAlign: 'right', marginLeft: 'auto' }}>
                                    <div><strong>Listă #{currentList.id}</strong></div>
                                    <div>Creată pe: {new Date(currentList.created_at).toLocaleDateString('ro-RO')}</div>
                                </div>
                            )}
                        </div>
                        <div className="list__table-wrapper">

                            <div className="list__table-content">
                                {!isMobile ? (
                                    <Table
                                        dataSource={searchQuery.length > 0 ? searchResults : lists}
                                        columns={listColumnsDesktop}
                                        rowKey="id"
                                        rowSelection={rowSelection}
                                        pagination={false}
                                        scroll={{ x: true }}
                                        expandable={{
                                            expandedRowRender,
                                            expandedRowKeys,
                                            onExpand: handleExpandRow,
                                            rowExpandable: (record) => Boolean(record.has_sublists),
                                            showExpandColumn: false
                                        }}
                                    />
                                ) : (
                                    <MobileList />
                                )}
                            </div>

                        </div>
                        {!isMobile && (
                            <div className='list__table-footer'>
                                <h4 className='list__table-footer-info'>
                                    Selectează mai multe liste pentru a accesa acțiuni multiple.
                                </h4>
                                <Dropdown
                                    menu={{
                                        onClick: ({ key }) => {
                                            if (key === 'merge') {
                                                setIsMergeModalVisible(true);
                                            }
                                            if (key === 'delete') {
                                                setIsBulkDeleteModalVisible(true);
                                            }
                                        },
                                        items: [
                                            {
                                                key: 'merge',
                                                label: 'Unește liste',
                                                disabled: selectedRowKeys.length < 2
                                            },
                                            {
                                                key: 'delete',
                                                label: 'Șterge liste',
                                                danger: true,
                                                disabled: selectedRowKeys.length === 0
                                            }
                                        ]
                                    }}
                                    disabled={selectedRowKeys.length === 0}
                                >
                                    <Button
                                        type="primary"
                                        className="list__save-button"
                                        disabled={selectedRowKeys.length === 0}
                                    >
                                        Acțiuni multiple <DownOutlined />
                                    </Button>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <MobileBottomMenu />

            <Modal
                title="Confirmă ștergere"
                open={isDeleteModalVisible}
                onOk={() => handleDeleteList(currentList)}
                onCancel={handleCancelDelete}
                okText="Șterge"
                cancelText="Cancel"
            >
                <p>Sunteți sigur că doriți să ștergeți aceasta lista?</p>
            </Modal>
            <Modal
                title="Confirmă ștergerea multiplă"
                open={isBulkDeleteModalVisible}
                onOk={handleBulkDelete}
                onCancel={() => setIsBulkDeleteModalVisible(false)}
                okText="Șterge toate"
                cancelText="Renunță"
            >
                <p>Sunteți sigur că doriți să ștergeți {selectedRowKeys.length} listă/liste?</p>
            </Modal>
            <Modal
                title="Programează liciație"
                open={isScheduleModalVisible}
                onCancel={closeScheduleModal}
                footer={null}
            >
                {scheduleStep === 1 && (
                    <Form
                        form={scheduleForm}
                        layout="vertical"
                        onFinish={() => setScheduleStep(2)}
                    >
                        <Form.Item
                            label="Setează ora și data"
                            name="date"
                            rules={[
                                { required: true, message: 'Selectează data și ora!' },
                                {
                                    validator: (_, value) => {
                                        if (!value || !moment(value).isBefore(moment())) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject(new Error('Nu poți selecta o dată/ora din trecut!'));
                                    }
                                }
                            ]}
                        >
                            <Input
                                type="datetime-local"
                                min={toDateTimeLocalValue(moment())}
                                value={scheduledDateInput}
                                onChange={(e) => {
                                    handleScheduledDateChange(e.target.value);
                                }}
                            />
                        </Form.Item>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <Button onClick={closeScheduleModal}>
                                Închide
                            </Button>
                            <Button type="primary" htmlType="submit">
                                Mergi la pasul 2
                            </Button>
                        </div>
                    </Form>
                )}

                {scheduleStep === 2 && (
                    <Form
                        layout="vertical"
                        onFinish={() => {
                            console.log("Listă:", selectedList);
                            console.log("Data programată:", scheduledDate);
                            console.log("Opțiune furnizori:", selectedSuppliersOption);
                            setIsScheduleModalVisible(false);
                        }}
                    >
                        <Form.Item label="Selectează răspuns" required>
                            <Radio.Group
                                value={selectedSuppliersOption}
                                onChange={(event) => {
                                    const nextValue = event.target.value;
                                    setSelectedSuppliersOption(nextValue);
                                    if (nextValue !== 'custom') {
                                        setSelectedScheduleSupplierIds([]);
                                    }
                                }}
                            >
                                <Radio value="all">Da, trimite tuturor</Radio>
                                <Radio value="custom">Nu, vreau să aleg furnizori</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {selectedSuppliersOption === 'custom' && (
                            <Form.Item label="Caută furnizor" required>
                                <Select
                                    mode="multiple"
                                    value={selectedScheduleSupplierIds}
                                    onChange={value => setSelectedScheduleSupplierIds(value)}
                                    placeholder="ex. Cuneco ..."
                                    optionFilterProp="children"
                                    showSearch
                                >
                                    {suppliersList.map((supplier) => (
                                        <Option key={supplier.id} value={supplier.id}>{supplier.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <Button onClick={closeScheduleModal}>
                                Închide
                            </Button>
                            <Button onClick={() => setScheduleStep(1)}>
                                Înapoi
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                onClick={scheduleList}
                                disabled={selectedSuppliersOption === 'custom' && selectedScheduleSupplierIds.length === 0}
                            >
                                Programează
                            </Button>
                        </div>
                    </Form>
                )}
            </Modal>
            <Modal
                title="Unește liste"
                open={isMergeModalVisible}
                onCancel={() => setIsMergeModalVisible(false)}
                onOk={() => {
                    if (!newListTitle.trim()) {
                        return toast.error('Te rugăm să introduci un titlu pentru lista nouă.');
                    }
                    handleMergeLists(newListTitle);
                    setIsMergeModalVisible(false);
                    setNewListTitle('');
                }}
                okText="Unește"
                cancelText="Anulează"
            >
                <Form layout="vertical">
                    <Form.Item label="Titlu listă nouă" required>
                        <Input
                            value={newListTitle}
                            onChange={(e) => setNewListTitle(e.target.value)}
                            placeholder="Introdu titlul listei noi"
                        />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Trimite Lista"
                open={isDirectSendModalVisible}
                onCancel={() => {
                    setIsDirectSendModalVisible(false);
                    setSelectedDeliveryMethods(['email']);
                }}
                onOk={() => {
                    handleDirectSend();
                    setIsDirectSendModalVisible(false);
                }}
                okButtonProps={{
                    disabled:
                        !selectedSupplierIds ||
                        selectedSupplierIds.length === 0 ||
                        !selectedDeliveryMethods.length
                }}
                okText="Trimite Lista"
                cancelText="Anulează"
            >
                <Form layout="vertical">
                    <Form.Item label="Selectează furnizorii cărora vrei să le trimiți lista (Email)">
                        <Select
                            mode="multiple"
                            value={selectedSupplierIds}
                            onChange={value => setSelectedSupplierIds(value)}
                            placeholder="Alege unul sau mai mulți furnizori"
                            optionFilterProp="children"
                            showSearch
                        >
                            {suppliersList.map((supplier) => (
                                <Option key={supplier.id} value={supplier.id}>{supplier.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Metodă de trimitere">
                        <Checkbox.Group
                            value={selectedDeliveryMethods}
                            onChange={(values) => {
                                const nextValue = Array.isArray(values) ? values : [];
                                if (nextValue.length <= 1) {
                                    setSelectedDeliveryMethods(nextValue);
                                    return;
                                }

                                setSelectedDeliveryMethods([nextValue[nextValue.length - 1]]);
                            }}
                            options={[
                                { label: 'Email', value: 'email' },
                                { label: 'WhatsApp (în curând)', value: 'whatsapp', disabled: true }
                            ]}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ReadyToSend;
